import type { ApiResponse, Session } from '@/types/global'
import axios from '../plugins/axios'
import { context } from '.'

export const fetchSessions = async (fields?: string[], branchId?: number) => {
  const response = await axios.post<ApiResponse<Session[]>>(`/api/${context}/api/1.0/session`, {
    jsonrpc: '2.0',
    params: {
      fields,
      filter: branchId ? [['company_branch_id', '=', parseInt(branchId as any)]] : undefined
    }
  })

  return response.data.result
}

export const fetchSession = async (id: number) => {
  const response = await axios.post<ApiResponse<Session>>(
    `/api/${context}/api/${import.meta.env.VITE_API_VERSION}/session/${id}`,
    {
      jsonrpc: '2.0',
      params: {}
    }
  )

  return response.data.result
}
